import React from 'react'
import { Switch } from 'react-router-dom'

import { PermissionRoute } from '../../common/components/routes'
import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import {
  IngredientCommonNegativeSynonymsPage,
  IngredientDetailsPage,
  IngredientsPage,
  IngredientSpecialCaseEditorPage,
  IngredientSpecialCasesPage,
} from './pages'

const IngredientsRouter = () => (
  <Switch>
    <PermissionRoute
      exact
      path={APP_ROUTES.INGREDIENTS.link}
      permissions={[PERMISSIONS.INGREDIENT.LIST]}
      component={IngredientsPage}
    />
    <PermissionRoute
      exact
      path={
        APP_ROUTES.INGREDIENTS.subMenuItems.INGREDIENT_COMMON_NEGATIVE_SYNONYMS
          .link
      }
      permissions={[PERMISSIONS.INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE.LIST]}
      component={IngredientCommonNegativeSynonymsPage}
    />
    <PermissionRoute
      exact
      path={APP_ROUTES.INGREDIENTS.subMenuItems.INGREDIENT_SPECIAL_CASES.link}
      permissions={[PERMISSIONS.INGREDIENT_SPECIAL_CASE.LIST]}
      component={IngredientSpecialCasesPage}
    />
    <PermissionRoute
      permissions={[PERMISSIONS.INGREDIENT_SPECIAL_CASE.CREATE]}
      exact
      path={APP_ROUTES.INGREDIENT_SPECIAL_CASE_CREATE.link}
      component={IngredientSpecialCaseEditorPage}
    />
    <PermissionRoute
      permissions={[
        PERMISSIONS.INGREDIENT_SPECIAL_CASE.UPDATE,
        PERMISSIONS.INGREDIENT_SPECIAL_CASE.GET,
      ]}
      exact
      path={APP_ROUTES.INGREDIENT_SPECIAL_CASE_DETAILS.link}
      component={IngredientSpecialCaseEditorPage}
    />
    <PermissionRoute
      exact
      path={APP_ROUTES.INGREDIENT_DETAILS.link}
      permissions={[PERMISSIONS.INGREDIENT.GET]}
      component={IngredientDetailsPage}
    />
  </Switch>
)

export default IngredientsRouter
